<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <v-btn
                class="mx-2"
                fab
                x-small
                color="primary"
                @click="$router.back()"
              >
                <v-icon dark> mdi-arrow-left </v-icon>
              </v-btn>
              <h3 class="font-weight-bold" v-text="'Store Product'"></h3>
              <v-btn
                class="mx-2 mb-2"
                fab
                x-small
                color="primary"
                to="store-products/create"
              >
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
              <v-btn
                class="mx-2 mb-2"
                fab
                x-small
                color="primary"
                to="store-products/upload"
              >
                <v-icon dark> mdi-upload </v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        x-small
                        rounded
                        depressed
                        color="error"
                        class="my-auto"
                        @click="deleteAll(store_products.id)"
                        style="width: 90px; height: 50px"
                      >
                        <v-icon dark> mdi-delete </v-icon>
                      </v-btn>
                    </template>
                    <span>Delete all Store</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="store_products.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                class="primary mx-4"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="900"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          @change="selectAll()"
                          v-model="is_select_all"
                        />&nbsp; Sr. No.
                      </th>
                      <th class="text-left">Status</th>
                      <th class="text-left" style="min-width: none">Store</th>
                      <th class="text-left" style="min-width: none">Store Location</th>
                      <th class="text-left" style="min-width: none">Store Code</th>
                      <th class="text-left" style="min-width: none">Product</th>
                      <th class="text-left" style="min-width: none">
                        Allotted Quantity
                      </th>
                      <th class="text-left" style="min-width: none">
                        Current Quantity
                      </th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="store_products.length != 0">
                    <tr
                      v-for="(store_product, i) in store_products"
                      :key="`store_product_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': store_products.length - 1 == i,
                      }"
                    >
                      <td>
                        <input
                          type="checkbox"
                          v-model="store_product.is_selected"
                        />
                        &nbsp;{{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="store_product.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span> Store Products is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="store_product.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Store Products is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{
                          store_product.store
                            ? store_product.store.business_name
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          store_product.store
                            ? store_product.store.store_location
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          store_product.store
                            ? store_product.store.store_code
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          store_product.product
                            ? store_product.product.name
                            : ""
                        }}
                      </td>
                      <td>{{ store_product.alloted_quantity || "" }}</td>
                      <td>{{ store_product.current_quantity || "" }}</td>
                      <td class="text-right">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="mr-2"
                              fab
                              x-small
                              color="primary"
                              :to="`/store-products/${encryptIt(
                                store_product.id
                              )}/product-stocks`"
                            >
                              <v-icon dark> mdi-plus </v-icon>
                            </v-btn>
                          </template>
                          <span>Add New Product Stocks</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              fab
                              x-small
                              class="my-auto"
                              color="error"
                              @click="Delete_this(store_product.id)"
                            >
                              <v-icon dark> mdi-delete </v-icon>
                            </v-btn>
                          </template>
                          <span>Delete this Store Products</span>
                        </v-tooltip>
                        <!-- Clear Success Dialog Box -->
                        <v-dialog
                          v-model="is_deleted_store_product"
                          width="600"
                        >
                          <v-card rounded="xxl">
                            <v-container>
                              <v-row align="center">
                                <v-col sm="3" align="center">
                                  <v-icon
                                    large
                                    color="error"
                                    style="
                                      font-size: 90px;
                                      width: 200px !important;
                                    "
                                  >
                                    mdi-delete-empty
                                  </v-icon>
                                </v-col>
                                <v-col sm="9" align="center">
                                  <v-card-text>
                                    <v-row>
                                      <v-col>
                                        <h1 style="color: red">Delete!</h1>
                                        <br />
                                        <h3>
                                          Are you sure, you want to delete ?.
                                        </h3>
                                        <br />

                                        <v-btn
                                          class="mr-10"
                                          color="success"
                                          @click="confirmDelete"
                                        >
                                          Yes
                                        </v-btn>
                                        <v-btn
                                          class="ml-10"
                                          color="error"
                                          @click="
                                            is_deleted_store_product = false
                                          "
                                        >
                                          Cancel
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                  </v-card-text>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card>
                        </v-dialog>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="8" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_store_product" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Store Product deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_store_product = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "StoreProductsPage",
  data() {
    return {
      form: {
        store_product_id: "",
        store_id: "",
      },
      filter: {
        search_keyword: "",
        is_active: "",
        is_selected: false,
      },
      store_products: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      isLoading: false,
      delete_store_product: false,
      is_deleted_store_product: false,
      is_select_all: false,
      // is_restored_product_stock: false,
      isDeleteAll: false,
    };
  },
  watch: {
    page: "getData",
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.store_id = this.decryptIt(this.$route.params.storeId);
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&is_active=" +
        this.filter.is_active +
        "&store_id=" +
        this.filter.store_id +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`store_products?${query}`)
        .then((response) => {
          this.store_products = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },

    async Delete_this(id) {
      this.deleteId = id; // Store the id of the item to delete
      this.is_deleted_store_product = true; // Show the confirmation dialog
    },
    async confirmDelete() {
      this.is_deleted_store_product = true;
      await axios
        .post(`/store_products/delete/${this.encryptIt(this.deleteId)}`)
        .then(() => {
          this.is_deleted_store_product = true;
          this.getData();
          this.is_deleted_store_product = false;
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    selectAll() {
      console.log(this.is_select_all);
      this.store_products.forEach((store_product) => {
        store_product.is_selected = this.is_select_all;
      });
    },
    async deleteAll() {
      this.isDeleteAll = true;
      let deleteallIds = [];
      this.store_products.forEach((store_product) => {
        if (store_product.is_selected) deleteallIds.push(store_product);
      });
      await axios
        .post("/store_products/alldelete", { deleteallIds })
        .then(() => {
          this.filter.status = "";
          this.getData();
        })
        .catch(function (error) {
          this.getData();
          console.log(error);
        });
      // let response = await axios.post(/sync_users/update_date_all, this.form);
      this.isDeleteAll = false;
    },
    async productStockCreate(store_id, product_id) {
      this.form.store_id = store_id;
      this.form.store_product_id = product_id;
      // console.log(this.form);
      try {
        this.isLoading = true;
        await axios.post("/product_stocks", this.form);
        this.isLoading = false;
        // await this.saveUserTimestamp(null, this.form);
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
    async generateExcel() {
      this.isExcelLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.store_id = this.decryptIt(this.$route.params.storeId);
      let response = [];
      let query =
        "role_id=3" +
        "&companyId=" +
        this.company.id +
        "&is_active=" +
        this.filter.is_active +
        "&store_id=" +
        this.filter.store_id +
        "&search_keyword=" +
        this.filter.search_keyword;
      response = await axios
        .get(`/store_products/excel_export?${query}`)
        .then((response) => window.open(`${response.data.data}`, "_blank"));
      if (response) {
        console.log(response);
      }
      this.isExcelloading = false;
    },
    isDeletePage() {
      let response = false;
      if (this.$route.query.open_trash) {
        response = true;
      }
      return response;
    },
  },
};
</script>
